import { inject, provideAppInitializer, EnvironmentProviders, DOCUMENT } from '@angular/core'
import { AuthService } from '@features/auth/auth.service'
import { Location } from '@angular/common'

const TOKEN_KEY = 'impersonate'

export function impersonateLoginInitializerFactory(document: Document, auth: AuthService, location: Location) {
  return () => {
    const url = new URL(document.URL)
    const queryParams = url.searchParams
    const token = queryParams.get(TOKEN_KEY)

    if (!token) {
      return
    }

    auth.forceCredentials({ access_token: token })

    queryParams.delete(TOKEN_KEY)
    location.replaceState(url.pathname, queryParams.toString())
  }
}

export const providers: EnvironmentProviders[] = [
  provideAppInitializer(() => {
        const initializerFn = (impersonateLoginInitializerFactory)(inject(DOCUMENT), inject(AuthService), inject(Location))
        return initializerFn()
      }),
]
